import { FormSection } from '@ksyos/design-system';
import type { IOorkV1ProcedureCustomControlData } from '@common/interfaces/ophthalmology/OorkAndOcrk/oorkV1ProcedureCustomControlData';
import { booleanAsJaNee } from '@common/utils/textUtils';
import { FormGroupRead } from '../../../utils/v1/FormGroupRead';

export interface IOorkPermissionsReadProps {
    customControlData: IOorkV1ProcedureCustomControlData;
}

export function OorkPermissionsRead(props: IOorkPermissionsReadProps) {
    const {
        customControlData: { inspection_rights_consented, share_medical_info_consented },
    } = props;

    return (
        <>
            {inspection_rights_consented !== null && (
                <FormSection
                    isBorderless={true}
                    title={'Inzage- en blokkeringsrecht'}
                >
                    <FormGroupRead
                        label="Besproken met betrokkene"
                        value={booleanAsJaNee(inspection_rights_consented)}
                    />
                </FormSection>
            )}

            {share_medical_info_consented !== null && (
                <FormSection
                    isBorderless={true}
                    title={'Toestemming delen medisch informatie met CBR'}
                >
                    <FormGroupRead
                        label="Besproken met betrokkene"
                        value={booleanAsJaNee(share_medical_info_consented)}
                    />
                </FormSection>
            )}
        </>
    );
}
